import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=746bf381&scoped=true&"
import script from "./BaseTitle.vue?vue&type=script&lang=js&"
export * from "./BaseTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseTitle.vue?vue&type=style&index=0&id=746bf381&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bf381",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
